import { render, staticRenderFns } from "./SupplementDecisionDialog.vue?vue&type=template&id=3570de6b&scoped=true"
import script from "./SupplementDecisionDialog.vue?vue&type=script&lang=js"
export * from "./SupplementDecisionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3570de6b",
  null
  
)

export default component.exports